import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Mes } from '@shared/models';
import * as moment from 'moment';

@Component({
  selector: 'app-selecionar-periodo-previsao-lancamento',
  templateUrl: './selecionar-periodo-previsao-lancamento.component.html',
  styleUrls: ['./selecionar-periodo-previsao-lancamento.component.css'],
})
export class SelecionarPeriodoPrevisaoLancamentoComponent implements OnInit {
  @Output() initialMonthChange: EventEmitter<Mes> =  new EventEmitter();
  @Output() finalMonthChange: EventEmitter<Mes> =  new EventEmitter();
  @Output() yearChange: EventEmitter<number> =  new EventEmitter();

  @Input() initialMonth: Mes;
  @Input() finalMonth: Mes;

  private _year: number;

  lsMeses: Mes[] = [];
  lsAnos: number[] = [];

  ngOnInit(){
    this.getMeses();
    this.getYears();
  }

  getMeses(){
    const meses:Mes[] = [];
    for (let i = 0; i < 12; i++) {
      meses.push({
        id: i,
        name: moment().locale('pt-br').month(i).format('MMMM')
      })
    }

    this.lsMeses = meses;
  }

  getYears(){
    const actualYear = moment().year();

    const lsAnos: number[] = [actualYear+1, actualYear, actualYear-1]
    this.lsAnos = lsAnos;
  }

  setInitialMonth(id:number){
    this.initialMonthChange.emit(this.lsMeses.find(item => item.id == id))
  }

  setFinalMonth(id:number){
    this.finalMonthChange.emit(this.lsMeses.find(item => item.id == id))
  }

  @Input()
  get year(): number{
    return this._year;
  }

  set year(year:number){
    this._year = year;
    this.yearChange.emit(year)
  }
}
